import { get } from '../utils'

export default host => ({ clientId, startDate, endDate }) =>
    get(`${host}/clients/${clientId}/people/generateExportLink?client_id=${clientId}${startDate && endDate ? `&date_start=${startDate}&date_end=${endDate}` : ""}`)
    .then(response => response.text())
  
  